<div [id]="'input-'+title" #input class="input bg-white border rounded-t flex justify-end items-center rounded-b" [ngClass]="{'rounded-b': isHidden, 'rounded-none': !isHidden, 'invalid': hasErrors, 'disabled': disabled || false}">
    <input [id]="'dataText-'+title" #readOnlyInput (focus)="isHidden = false" [disabled]="disabled || false" [(ngModel)]="textValues" [ngModelOptions]="{standalone: true}" [placeholder]="placeholder" readonly class="border-none z-0 block w-full h-full px-3 py-2 bg-white border rounded-s rounded-e text-base font-normal placeholder-slate-400 focus:outline-none text-ellipsis overflow-hidden" [class.pl-8]="iconLeft" />
    @if (hasErrors) {
        <img [src]="images.error" class="absolute mr-8 w-6" alt="errorIcon" />
    }
    <img [hidden]="!isHidden" (click)="disabled! ? $event.stopPropagation() : readOnlyInput.focus()" [src]="images.arrowDown" class="h-3 w-3 my-2 mx-3" />
    <img [hidden]="isHidden" (click)="disabled! ? $event.stopPropagation() : isHidden = true" [src]="images.arrowUp" class="h-3 w-3 my-2 mx-3" />
</div>
@if (hasErrors) {
    <label class="text-xs hasErrors">{{ error }}</label>
}
<div [id]="'dropdown-'+title" #dropdown [class]="'scrollable-content dropdown shadow z-50 absolute bg-white border rounded rounded-t-none border-t-0 ' + 'w-' + width" [ngClass]="{ 'fadeIn': !isHidden, 'fadeOut': isHidden, 'search': showSearch }" [style.max-height]="dropdownMaxHeight">
    @if (showSearch) {
        <div class="rounded-s rounded-e flex border justify-start items-center m-2">
            <div class="relative w-full">
                <div class="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                    <img [src]="images.search" class="w-6 h-6 text-gray-500 dark:text-gray-400" />
                </div>
                <input #search [id]="'search-'+title" (focus)="isHidden = false" [(ngModel)]="searchableText" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterElements()" [placeholder]="literalService.get('search', true)" class="border-none pl-9 z-0 block w-full h-full px-3 py-2 bg-white border rounded-s rounded-e text-sm placeholder-slate-400 focus:outline-none" />
            </div>
        </div>
    }
    @if (showSelectAll) {
        <div class="flex justify-start items-center w-full neutrals-grey-02-border" [ngClass]="{'border-t': showSearch}">
            <label class="text-base font-normal pl-2 w-full cursor-pointer flex items-center">
                <input [id]="'checkbox-selectAll-'+title" type="checkbox" class="mr-2 shrink-0 focus:ring-transparent cursor-pointer" (change)="toggleSelectAll($event)" [checked]="selectAllChecked" />
                <span class="truncate">{{ literalService.get(selectAllLabel, true) }}</span>
            </label>
        </div>
        <article class="border-t neutrals-grey-02-border mx-2"></article>
    }
    @if (pinSelectedToTop) {
        @let pinned = pinnedElements;
        @for (item of pinned; track item.id ?? item; let i = $index) {
            <div [id]="getValue(item)" class="flex justify-start items-center w-full">
                <label class="text-base font-normal pl-2 w-full cursor-pointer flex items-center">
                    <input [id]="'checkbox'+getValue(item)" [attr.data-value]="item.id || item" type="checkbox" class="mr-2 shrink-0 focus:ring-transparent cursor-pointer" (change)="onChange($event)" [checked]="checked(item)" />
                    <span [id]="'label-'+getValue(item)" [tooltip]="getValue(item)" [position]="TooltipPosition.DYNAMIC" [visibleTooltip]="utilsService.visibleTooltip('label-'+getValue(item))" class="truncate">
                        {{ getValue(item) }}
                    </span>
                </label>
            </div>
        }
    } @else {
        @for (item of elements; track $index) {
            <div [id]="getValue(item)" class="flex justify-start items-center w-full">
                <label class="text-base font-normal pl-2 w-full cursor-pointer flex items-center">
                    <input [id]="'checkbox'+getValue(item)" [attr.data-value]="item.id || item" type="checkbox" class="mr-2 shrink-0 focus:ring-transparent cursor-pointer" (change)="onChange($event)" [checked]="checked(item)" />
                    <span [id]="'label-'+getValue(item)" [tooltip]="getValue(item)" [position]="TooltipPosition.DYNAMIC" [visibleTooltip]="utilsService.visibleTooltip('label-'+getValue(item))" class="truncate">
                        {{ getValue(item) }}
                    </span>
                </label>
            </div>
        }
    }
</div>
